import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

interface MultiSelectProps {
  top100Films: { label: string; value: number }[];
  values: any;
  helperText?: string;
  error?: boolean;
  handleChange: (event: any, selectedData: any) => void;
  handleSearch: (data: any) => void;
  onBlur?: (e: any) => void;
  setPageCount?: (data: any) => void;
  setResetFlag?: (data: boolean) => void;
}

export default function EventEHRMultiSelectWithSearch({
  top100Films,
  values,
  helperText = "",
  error = false,
  handleChange,
  handleSearch,
  onBlur = (e) => {},
  setPageCount,
  setResetFlag,
}: MultiSelectProps) {
  const handleScrollDownEvent = () => {
    const lazyContainer = document.querySelector("#multiSelectWithSearch-listbox");
    if (
      lazyContainer &&
      top100Films &&
      top100Films.length > 0 &&
      setPageCount
    ) {
      lazyContainer.addEventListener("scroll", (event) => {
        if (
          Math.abs(
            lazyContainer.scrollHeight -
              lazyContainer.scrollTop -
              lazyContainer.clientHeight
          ) < 5
        ) {
          setPageCount((count: number) => count + 1);
        }
      });
    }
  };
  return (
    <Autocomplete
      size="small"
      value={values}
      multiple
      limitTags={2}
      id="multiple-limit-tags"
      options={top100Films.filter(
        (option) =>
          !values.some((selected: any) => selected.value === option.value)
      )} // Filter out already selected values      value={values} // Controlled value
      getOptionLabel={(option: any) => option.label}
      // defaultValue={[top100Films[13], top100Films[12], top100Films[11]]}

      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Users"
          placeholder="Search"
          onBlur={onBlur}
          helperText={helperText}
          error={error}
          onChange={handleSearch}
        />
      )}
      slotProps={{
        paper: {
          sx: {
            maxHeight: 200, // Set max height for the dropdown menu
            // overflow: "auto", // Enable scrolling if needed
            "& .MuiAutocomplete-listbox": {
              maxHeight: "none", // Remove any height restrictions on the listbox
            },
          },
        },
      }}
      ListboxProps={{
        id: "multiSelectWithSearch-listbox",
        style: {
          maxHeight: "200px", // Set the maximum height
          overflowY: "auto", // Enable scrolling
        },
      }}
      noOptionsText={"Please Search Users"}
      onChange={handleChange}
      onClose={(event, reason) => {
        if (reason === "escape" || reason === "toggleInput") {
          setTimeout(() => {
            handleScrollDownEvent();
          }, 100);
          setResetFlag && setResetFlag(true);
        }
      }}
      onOpen={() => {
        // 'onOpen' is fired when the popup requests to be opened. We need setTimeout for the component to load.
        setTimeout(() => {
          handleScrollDownEvent();
        }, 100);
      }}
      sx={{ width: "500px" }}
    />
  );
}
